import {
  Box,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const TABLE_COLUMNS = [
  "Brand Display Name",
  "FTD",
  "QFTD",
  "CPA Income",
  "Total Income",
  "CPA Constraint",
  "Remaining QFTD",
  "% Budget Used",
  "% QFTD Budget Used",
  "% QFTD RR Budget Used",
];

export default function BudgetTableSkeleton() {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {TABLE_COLUMNS.map((column) => (
              <TableCell key={column}>
                <Skeleton width={120} height={24} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {[...Array(7)].map((_, rowIndex) => (
            <TableRow key={rowIndex}>
              <TableCell>
                <Skeleton width={180} height={24} />
              </TableCell>

              <TableCell>
                <Skeleton width={40} />
              </TableCell>

              <TableCell>
                <Skeleton width={40} />
              </TableCell>

              <TableCell>
                <Skeleton width={80} />
              </TableCell>

              <TableCell>
                <Skeleton width={100} />
              </TableCell>

              <TableCell>
                <Skeleton width={90} />
              </TableCell>

              <TableCell>
                <Skeleton width={70} />
              </TableCell>

              <TableCell>
                <Skeleton variant="rounded" width={60} height={28} />
              </TableCell>

              <TableCell>
                <Skeleton variant="rounded" width={60} height={28} />
              </TableCell>

              <TableCell>
                <Skeleton variant="rounded" width={60} height={28} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Pagination Skeleton */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={2}
        py={1.5}
      >
        <Skeleton width={120} height={30} />
        <Skeleton width={120} height={30} />
      </Box>
    </TableContainer>
  );
}
